import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Button, Box, Flex } from "ui-components";
import map from "lodash/map";
import FAQItem from "components/FAQItem";
import PageHeader from "components/PageHeader";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { iconThemes, getButtonColorVariant } from "ui-components/theme";
import { isMiniApp } from "utils/localStorage";
import { formatPathUrl } from "utils/helpers";
import { useSelector } from "react-redux";
import {
  makeSelectLoggedInUserDetails,
  makeSelectOrderRef
} from "ducks/selectors";
import { getGTMtagdata } from "analytics/utils/helpers";

const PageFaqs = ({
  title,
  faq,
  more,
  titleProps = {},
  buttonProps = {},
  messageData,
  containerProps = {},
  faqProps = {},
  themeColors,
  locale = {}
}) => {
  const miniApp = isMiniApp();
  const containerName = formatPathUrl(window.location.pathname);
  const loggedInUserDetails = useSelector(makeSelectLoggedInUserDetails());
  const orderRef = useSelector(makeSelectOrderRef());

  return isEmpty(faq) && isEmpty(more) ? null : (
    <Box
      variant="faqs"
      sx={{ boxShadow: "none" }}
      px="18px"
      id="page-faqs"
      {...containerProps}
    >
      {title && (
        <Box width={["100%"]} paddingBottom="0">
          <PageHeader
            title={title}
            themeColors={{ secondary: iconThemes.purple }}
            {...titleProps}
          />
        </Box>
      )}
      {map(faq, (faq, index) => {
        return (
          <FAQItem
            key={index}
            {...faq}
            faqProps={faqProps}
            messageData={messageData}
            themeColors={themeColors}
            data-gtmdata={getGTMtagdata(
              containerName,
              `"faq_toggle"${index}`,
              loggedInUserDetails,
              faq,
              orderRef,
              locale
            )}
          />
        );
      })}
      <Flex justifyContent="space-evenly" padding="1rem">
        {!isEmpty(more) && !miniApp && (
          <Button
            as="a"
            variant="outline"
            sx={getButtonColorVariant(themeColors?.button, "outline")}
            target={miniApp ? "_self" : "_blank"}
            href={get(more, "link")}
            {...buttonProps}
            data-gtmdata={getGTMtagdata(
              `${containerName}_more_faq_button`,
              "more_faq",
              loggedInUserDetails,
              more,
              orderRef,
              locale
            )}
          >
            <FormattedMessage
              id={get(more, "label")}
              data-gtmdata={getGTMtagdata(
                `${containerName}_more_faq_button`,
                "more_faq",
                loggedInUserDetails,
                more,
                orderRef,
                locale
              )}
            />
          </Button>
        )}
      </Flex>
    </Box>
  );
};

PageFaqs.defaultProps = {
  title: "",
  faq: [],
  more: {},
  messageData: {}
};

export default PageFaqs;
